'use client';

import { useRouter } from 'next/router';

import { RouterAdapter } from '../types';

export const usePageRouterAdapter = (): RouterAdapter => {
  const router = useRouter();

  return {
    push: router.push,
    replace: router.replace,
    back: router.back,
    reload: router.reload,
    pathname: router.pathname,
    isReady: router.isReady,
    query: router.query as Record<string, string | string[]>
  };
};
